// import Swiper from "swiper"
import { find } from "../utils/dom"

export default function () {
	const Home = find("[js-page='muay-thai-programs']")
	if (!Home) return
	console.log('Page Muay Thai Programs');


var swiperMuayThaiProgram = new Swiper(".swiper-muay-thai-program", {
	spaceBetween: 24,
	slidesPerView: 'auto',
	centeredSlides:true,
	initialSlide: 2,

	navigation: {
		nextEl: ".swiper-button-muay-thai-program-next",
		prevEl: ".swiper-button-muay-thai-program-prev",
	},
});

}